export enum CalloutSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}
